module.exports = __webpack_public_path__ + "media/images/syntax/ud63-1bab088fdffcfb27ce0fbdeaeaf5fda7.png";